import { useStore } from '@stores';
import { observer } from 'mobx-react';
import React from 'react';
import Presentation from './TechnicalCategoryContent.presentation';

interface IProps {
  category: string;
}

export const TechnicalCategoryContent: React.FC<IProps> = observer(({ category }) => {
  const { technicalCategoryStore } = useStore();
  const { subCategories } = technicalCategoryStore;

  return <Presentation category={category} subCategories={subCategories} />;
});
